module.exports = __webpack_public_path__ + "static/media/cleanvertising-black.e33bd9fc.woff2";